import React from "react";
import { Field } from "formik";

function FilteredPropsInputField({
    className,
    valid,
    style,
    error,
    inputType,
    ...props
}) {
    return (
        <Field
            as={inputType && inputType}
            className={className}
            style={style}
            {...props}
        />
    );
}

export default FilteredPropsInputField;
